const STORAGE_KEY = "bezpart-board-minimap-visible";

/** По умолчанию: на телефоне скрыта (меньше наложений), на десктопе — видна. */
export function readMinimapVisibleDefault(): boolean {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw === "0") return false;
    if (raw === "1") return true;
  } catch {
    /* ignore */
  }
  if (typeof window !== "undefined" && window.matchMedia("(max-width: 720px)").matches) {
    return false;
  }
  return true;
}

export function writeMinimapVisible(visible: boolean): void {
  try {
    localStorage.setItem(STORAGE_KEY, visible ? "1" : "0");
  } catch {
    /* ignore */
  }
}
